import { AppState, Auth0Provider } from "@auth0/auth0-react"
import { useNavigate } from "react-router-dom"
import { ReactNode } from "react"
import { EnvironmentService } from "../../services/EnvironmentService"

interface Props {
  children: ReactNode
}

export function Auth0ProviderWithRedirectCallback({ children }: Props) {
  const navigate = useNavigate()

  const onRedirectCallback = (appState?: AppState) => {
    navigate((appState && appState.returnTo) || window.location.pathname)
  }

  return (
    <Auth0Provider
      onRedirectCallback={onRedirectCallback}
      domain={EnvironmentService.getAuth0Domain() ?? ""}
      clientId={EnvironmentService.getAuth0ClientId() ?? ""}
      redirectUri={EnvironmentService.getAuth0LoginRedirect() ?? ""}
      audience={EnvironmentService.getAuth0Audience() ?? ""}
      realm={EnvironmentService.getAuth0Realm() ?? ""}
      useRefreshTokens
      cacheLocation="localstorage"
      env={EnvironmentService.getEnv()}
      app="referral"
    >
      {children}
    </Auth0Provider>
  )
}
